import { h, Component } from 'preact'
import linkState from 'linkstate'

import Input from 'app/components/Input'
import Form from 'app/components/Form'
import Button from 'app/components/Button'
import { connect } from 'app/store'
import { Link } from 'preact-router'

class Login extends Component {
  state = {
    email: '',
    password: '',
  }

  render(props, state) {
    const { login } = props
    const { email, password } = state

    return (
      <div>
        <div class="row mt-5">
          <div class="col-lg-4 col-sm-12 col-xs-12 mx-auto">
            <h3 class="mb-5 text-center">Log In</h3>
            <Form onSubmit={() => login(email, password)}>
              <Input
                label="Username or Email"
                value={email}
                type="text"
                class="mb-3 w-100"
                required
                onInput={linkState(this, 'email')}
              />
              <Input
                label="Password"
                value={password}
                type="password"
                class="mb-3 w-100"
                required
                onInput={linkState(this, 'password')}
              />
              <Button type="submit" class="float-right">
                Sign In
              </Button>
            </Form>
          </div>
        </div>
        <div class="row">
          <div class="col py-5 text-center">
            <Link class="text-muted" href="/join">Not a member?</Link>
            <span class="mx-3">|</span>
            <Link class="text-muted" href="/forgot">Forgot password?</Link>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  Login,
)



// WEBPACK FOOTER //
// ./pages/Login.js